import { isAndroid, isIOS } from 'react-device-detect';

import { getCallbackUrl } from '@/lib/dmm/accounts';

export enum PayType {
  Paypay = 'paypay',
  Merpay = 'merpay',
  Bank = 'bank',
  Credit = 'credit',

  Skyflag = 'Skyflag',
  Prize = 'prize',
  Transfer = 'transfer',
}

type ToretaChargeUrlArgs = {
  payType?: PayType;
  backPath?: string;
};

const baseUrl = import.meta.env.VITE_DMM_POINT_URL;

export const toretaChargeBaseUrl = `${baseUrl}/choice/pay?basket_service_type=chariloto_toreta`;
export const getToretaChargeUrl = (args?: ToretaChargeUrlArgs) => {
  return `${toretaChargeBaseUrl}&back_url=${getCallbackUrl(
    args?.backPath || '',
  )}${args?.payType ? `&pay_type=${args?.payType}` : ''}`;
};

export const getToretaChargeCreditUrl = (args?: ToretaChargeUrlArgs) => {
  return `${toretaChargeBaseUrl}&back_url=${getCallbackUrl(
    args?.backPath || '',
  )}&pay_type=credit`;
};

export const toretaPinChargeBaseUrl = `${baseUrl}/pointcode/input/chariloto_toreta`;
export const getToretaPinChargeUrl = (backPath?: string) => {
  return `${toretaPinChargeBaseUrl}?back_url=${getCallbackUrl(backPath)}`;
};

export const getSkyflagLink = (userId: string) => {
  let owp: string = import.meta.env.VITE_SKYFLAG_PC_OWP;
  if (isIOS) {
    owp = import.meta.env.VITE_SKYFLAG_IOS_OWP;
  }
  if (isAndroid) {
    owp = import.meta.env.VITE_SKYFLAG_ANDROID_OWP;
  }

  return `${import.meta.env.VITE_SKYFLAG_BASE_URL}?_owp=${owp}&suid=${userId}`;
};
